import { Button, TextField } from '@material-ui/core';
import { EditorRow } from 'components/common/styles';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { ModalWrapper } from '../../../components/ModalWrapper';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import AudioSetsModel from '../../../models/AudioSetsModel';
import TtsVoiceSelect from '../../../components/selects/TtsVoiceSelect';

type IProps = {
  onClose: () => void;
  readBy: 'm' | 'f' | 'mf';
  ssmlCode: string;
  prompt: string;
  onItemDone: (itemId: number) => Promise<void>;
};

/** Gemini TTS only voices the Chirp3-HD family; the set's dialect narrows the list. */
const GEMINI_VOICE_FAMILY = 'Chirp3-HD';

const AudioTTS: React.FC<IProps> = (props) => {
  const [voiceNameM, setVoiceNameM] = useState('');
  const [voiceNameF, setVoiceNameF] = useState('');
  const [prompt, setPrompt] = useState(props.prompt);
  const [isLaunching, setIsLaunching] = useState(false);
  const moduleModel = useContext(ModuleContext) as AudioSetsModel;

  const handleGenerateClick = async () => {
    setIsLaunching(true);
    // Only the launch is awaited: the items are voiced in the background (see AudioSetsModel.startTTS)
    const launch = moduleModel.startTTS(voiceNameM, voiceNameF, prompt, props.onItemDone);
    props.onClose();
    await launch;
  };

  const isButtonEnabled = () => {
    let voiceSelected = false;
    switch (props.readBy) {
      case 'f':
        voiceSelected = voiceNameF !== '';
        break;
      case 'm':
        voiceSelected = voiceNameM !== '';
        break;
      case 'mf':
        voiceSelected = voiceNameM !== '' && voiceNameF !== '';
        break;
    }
    return voiceSelected && prompt.trim() !== '' && !isLaunching;
  };

  return (
    <ModalWrapper onClose={props.onClose} title={'TTS (Gemini)'} width={520} height={360}>
      {props.readBy.includes('m') && (
        <EditorRowStyled>
          <TtsVoiceSelect
            filter={[props.ssmlCode, GEMINI_VOICE_FAMILY, '- Male']}
            label={'Male'}
            onChange={setVoiceNameM}
          />
        </EditorRowStyled>
      )}
      {props.readBy.includes('f') && (
        <EditorRowStyled>
          <TtsVoiceSelect
            filter={[props.ssmlCode, GEMINI_VOICE_FAMILY, '- Female']}
            label={'Female'}
            onChange={setVoiceNameF}
          />
        </EditorRowStyled>
      )}
      <EditorRowStyled>
        <PromptField
          value={prompt}
          label={'Prompt'}
          variant="outlined"
          multiline
          rows={4}
          onChange={(event) => setPrompt(event.target.value)}
        />
      </EditorRowStyled>
      <EditorRowStyled>
        <Button variant="contained" size="small" disabled={!isButtonEnabled()} onClick={handleGenerateClick}>
          Generate
        </Button>
      </EditorRowStyled>
    </ModalWrapper>
  );
};

const EditorRowStyled = styled(EditorRow)`
  justify-content: flex-start;
  margin-top: 10px;
`;

const PromptField = styled(TextField)`
  && {
    width: 100%;
  }
`;

export default AudioTTS;
